import React from 'react'
import { FormProvider } from 'react-hook-form'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { makeStyles } from 'transfix-ui/core'
import { IConnectionTypes } from 'types/graphqlTypes'
import { AddInboundConnectionConfigModalForm } from '../../forms/AddInboundConnectionConfigModalForm'
import { useAddInboundConnectionConfigModalForm } from '../../forms/useAddInboundConnectionConfigModalForm'
import { TAddInboundConnectionConfigModalSchema } from '../../schema/AddInboundConnectionConfigModalSchema'

interface IAddInboundConnectionConfigModalProps extends Omit<IModalBaseProps, 'modalType'> {
  defaultValues?: {}
  onSubmit: (options: TAddInboundConnectionConfigModalSchema) => void
}

const useAddInboundConnectionConfigModalStyles = makeStyles({
  body: {},
  modal: {},
  header: {},
  title: {},
  root: {},
})

const getDefaultValues = () => {
  return {
    connectionType: IConnectionTypes.SFTP_WITH_PRIVATE_KEY,
    company: {},
    isDisabled: true,
    port: 0,
    username: '',
    secretKey: '',
    pathPrefix: '',
    filenameGlob: '',
    host: '',
    as2ConnectionConfigId: '',
    send997s: true,
  }
}

export const AddInboundConnectionConfigModal = ({
  defaultValues,
  onClose,
  onSubmit,
  open = false,
  ...props
}: IAddInboundConnectionConfigModalProps) => {
  const methods = useAddInboundConnectionConfigModalForm({
    defaultValues: defaultValues || getDefaultValues(),
  })

  const { handleSubmit } = methods || {}

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Cancel',
      action: () => {
        onClose()
      },
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
    {
      label: 'Save',
      action: handleSubmit((data: TAddInboundConnectionConfigModalSchema) => {
        onSubmit(data)
        onClose()
      }),
      type: 'confirm',
      dataTest: 'confirm-button',
    },
  ]

  const classes = useAddInboundConnectionConfigModalStyles()

  return (
    <ModalBase
      dataTest='AddInboundConnectionConfigModal'
      modalType={MODAL_TYPES.form}
      size={4}
      open={open}
      actions={actions}
      className={classes.root}
      bodyClassName={classes.body}
      titleClass={classes.title}
      modalClassName={classes.modal}
      headerClassName={classes.header}
      onClose={onClose}
      {...props}>
      <FormProvider {...methods}>
        <AddInboundConnectionConfigModalForm />
      </FormProvider>
    </ModalBase>
  )
}
